module.exports = __webpack_public_path__ + "static/Seller-5851cedfc1260baf1eb6b15b98f1c9ac.png";